import React, { Component } from 'react';
import SectionTitle from "../../UI/SectionTitle";
import HomeNewsItem from "./HomeNewsItem";
import SlickSlider from './../../UI/Slick/index';

import Slider from 'react-slick';

export default class HomeNews extends Component {
    constructor(props) {
        super(props);
        this.state = {
          duration: 3,
          slideIndex: 0,
          updateCount: 0,
          nav1: null,
          nav1Settings: null,
          nav2Settings: null,
          nav2: null,
          HomeNewsItems: []
        };
        
      }
      componentDidMount() {
    if (this.props.newsData) {
        
        this.setState({
            nav1: this.slider1,
            nav2: this.slider2,
            nav1Settings: {
              accessibility: true,
              adaptiveHeight: true,
                 arrows: false,
                dots: false,
                autoplay: true,
                afterChange: () =>
                    this.setState(state => ({ updateCount: state.updateCount + 1 })),
                beforeChange: (current, next) => {this.setState({ slideIndex: next });
                
                },
                responsive: [
                    {
                        breakpoint: 500,
                        settings: {
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            },
            nav2Settings: {
                arrows: false,
                dots: false,
                autoplay: false,
                className: "team-content-wrap slick-dots--light mtn-md-5",
responsive: [
    {
        breakpoint: 1550,
        settings: {
            slidesToShow: 3,
        }
    },
    {
        breakpoint: 700,
        settings: {
            slidesToShow: 2,
        }
    },
    {
        breakpoint: 550,
        settings: {
            slidesToShow: 1,
        }
    }
]
            },
            HomeNewsItems: this.props.newsData.data.news
          });
    }
        
        
      }
    

    render ()
{

    return (
        <div className="team-area" style={{height:"400px", marginBottom: '12%', marginTop: '3%'}}>
            <div className="row">
                    <div className="col-12 text-center">
                        <div style={{width:'10%', height:"5px", backgroundColor:'red', margin:"auto" }}/><br/>
                        <SectionTitle title=" " heading="اخبار"  txtcolor="#000"/>
                    </div>
                </div>
            <div className="row no-gutters align-items-center" style={{height:"400px", backgroundColor: '#ccc'}}>
                <div className="col-xl-4">
                <Slider
          {...this.state.nav1Settings}
            asNavFor={this.state.nav2}
            ref={slider => (this.slider1 = slider)}
          >
            {
                      this.state.HomeNewsItems.map(item => (
                          <div key={item.id}>
                             <div className="text-center text-md-left" style={{maxHeight:"400px", padding:"5%"}}>
                        {                            
                            <SectionTitle
                                variant="light"
                                title={item.displayText}
                                text={item.newsOverview.html}
                                txtcolor="#000"
                            />
                        }
    
                    </div>
                          </div>
                      ))
                  }
          </Slider>
                </div>
                <div className="col-xl-8">
            <Slider
            asNavFor={this.state.nav1}
            {...this.state.nav2Settings}
            ref={slider => (this.slider2 = slider)}
            slidesToShow={3}
            swipeToSlide={true}
            focusOnSelect={true}
          >
             {
                      this.state.HomeNewsItems.map((news, index) => (
                        <div key={news.id}>
                           
                            
                        <HomeNewsItem id={news.id} isActive={index === this.state.slideIndex}  name={news.bag.contentItems[0].displayText} newsTitle={news.displayText} newsImage={news.bag.contentItems[0].image.urls[0]} />
                    </div>
                      ))
                  }
          </Slider>
                </div>
            </div>
        </div>
    );
}
      



}
